/* ===========================================================
   Main Project — Brand JS
   Currently:
   - Scroll-Star toggle (REPRESENT-style header hide/restore)
   =========================================================== */

(function () {
  'use strict';

  const THRESHOLD = 80;        // px from top before star can appear
  const HYSTERESIS = 6;        // ignore tiny scroll jitter
  let lastY = window.scrollY;
  let ticking = false;
  const html = document.documentElement;

  function update() {
    ticking = false;
    const y = window.scrollY;
    const delta = y - lastY;

    if (y <= THRESHOLD) {
      // Always show header when near the top
      html.classList.remove('mp-scrolled');
    } else if (Math.abs(delta) > HYSTERESIS) {
      if (delta > 0) {
        // scrolling down → hide header, show star
        html.classList.add('mp-scrolled');
      } else {
        // scrolling up → restore header
        html.classList.remove('mp-scrolled');
      }
    }
    lastY = y;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update();

  // Smooth scroll for the back-to-top star
  document.addEventListener('click', function (e) {
    const star = e.target.closest('[data-mp-scroll-star]');
    if (!star) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
